var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { Api } from 'app/core/api.service';
import { camelCaseObject } from 'app/core/case-transform';
import { getFromToQuarter } from 'app/core/date/functions';
import { ISOStringForCurrentTime } from 'app/core/date/functions';
var ConsumptionService = /** @class */ (function () {
    function ConsumptionService(api) {
        this.api = api;
    }
    ConsumptionService.prototype.getBillOverview = function (owner, from, to) {
        var params = {
            from: ISOStringForCurrentTime(from),
            to: ISOStringForCurrentTime(to)
        };
        return this.api
            .get("/v2/system/task/" + owner.toLocaleLowerCase() + "/bills", { params: params })
            .pipe(map(function (response) { return camelCaseObject(response) || []; }));
    };
    ConsumptionService.prototype.getConsumption = function (serviceType, from, to) {
        if (from === void 0) { from = null; }
        if (to === void 0) { to = null; }
        var fromToQuater = getFromToQuarter();
        var params = {
            from: from ? ISOStringForCurrentTime(from) : ISOStringForCurrentTime(fromToQuater.from),
            to: to ? ISOStringForCurrentTime(to) : ISOStringForCurrentTime(fromToQuater.to)
        };
        var demoParams = {
            from: from ? ISOStringForCurrentTime(from) : new Date(0).toISOString(),
            to: to ? ISOStringForCurrentTime(to) : ISOStringForCurrentTime(fromToQuater.to)
        };
        return forkJoin([
            this.api.get("/v2/task/" + serviceType + "/bill", { params: demoParams }),
            this.api.get("/v2/task/" + serviceType + "/bill", { params: params })
        ]).pipe(map(function (responses) {
            var _a = __read(camelCaseObject(responses), 2), demoResponse = _a[0], customResponse = _a[1];
            return {
                demo: {
                    documentCount: demoResponse.demo.documentCount || 0,
                    pageCount: demoResponse.demo.pageCount || 0,
                },
                paid: {
                    documentCount: customResponse.paid.documentCount || 0,
                    pageCount: customResponse.paid.pageCount || 0,
                },
            };
        }));
    };
    return ConsumptionService;
}());
export { ConsumptionService };
